import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import { validate, validators } from 'validate-redux-form';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';
import {
    renderCurrencyFloat
} from "../../Utils/renderField/renderField";

function ImpuestosForm(props) {
    const { handleSubmit, crear, modulo } = props;

    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar impuesto' : 'Crear impuesto';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver impuesto'
    }
    let autoFocus = true;
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    
    return (
        <div>
            <NavbarModulo
                modulo={modulo}
                titulo={titulo}
            />
            <form onSubmit={handleSubmit}>
                <br />
                <div className="mb-4 card card-small text-white bg-dark mb-3">
                    <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                        <div className="d-flex flex-column flex-1 mx-4">
                            <div className='row'>
                                <div className='col-3'>
                                    <Field
                                        autoFocus={autoFocus}
                                        name="porcentaje_iva"
                                        placeholder="Porcentaje iva"
                                        className="form-control"
                                        component={renderCurrencyFloat}
                                        msj="Porcentaje iva"
                                    />
                                </div>
                                <div className='col-3'>
                                    <Field
                                        name="costo_galon_super"
                                        placeholder="Galón super"
                                        className="form-control"
                                        component={renderCurrencyFloat}
                                        msj="Galón super"
                                    />
                                </div>
                                <div className='col-3'>
                                    <Field
                                        name="costo_galon_regular"
                                        placeholder="Galón regular"
                                        className="form-control"
                                        component={renderCurrencyFloat}
                                        msj="Galón regular"
                                    />
                                </div>
                                <div className='col-3'>
                                    <Field
                                        name="costo_galon_diesel"
                                        placeholder="Galón diesel"
                                        className="form-control"
                                        component={renderCurrencyFloat}
                                        msj="Galón diesel"
                                    />
                                </div>
                            </div>
                            <div className='d-flex flex-row mt-3'>
                                {disabled == false &&
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        type='submit'
                                    >
                                        {editar ? 'Modificar' : 'Guardar'}
                                    </button>
                                }
                                <a
                                    href={`/#/ajustes/${id_emp[5]}/impuestos`}
                                    className='btn btn-secondary mb-3'
                                >
                                    Regresar
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

ImpuestosForm.propTypes = {
    handleSubmit: PropTypes.func,
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    modulo: PropTypes.object,
};

export default reduxForm({
    form: 'FormImportacionMod',
    validate: (data) => {
        return validate(data, {
            porcentaje_iva: validators.exists()('Este campo es requerido'),
        });
    },
})(ImpuestosForm);
